import React from "react";
import { Outlet } from "react-router-dom";
import GovHeader from "../../components/GovHeader/GovHeader";
import "./AppLayout.css";

export default function AppLayout() {
  return (
      <div className="app-shell">
        <GovHeader />
        <main className="main-content">
          <Outlet />
        </main>
        <footer className="gov-footer">
          <div className="footer-content">
            {/* Empty footer - just green background */}
          </div>
        </footer>
      </div>
  );
}
